export default "__VITE_ASSET__BKO6TwVN__"